import { BloodPressureItem } from 'models/bloodpressure';
import { BloodPressureDetails } from './BloodPressureDetails';

export const renderBloodPressureDetails = (item: BloodPressureItem) => {
  return <BloodPressureDetails item={item} />;
};
